// import {
//     AppBar, Toolbar, Typography, Box, IconButton, MenuItem,
//     Paper, Badge, Drawer, Divider, Switch, FormControlLabel
// } from "@mui/material";
// import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import useMediaQuery from '@mui/material/useMediaQuery';

// const Foodandbevaragenavbar = () => {
//     const navigate = useNavigate();
//     const [showContainer, setShowContainer] = useState(false);
//     const [cartCount, setCartCount] = useState(0);
//     const [cartItems, setCartItems] = useState([]);
//     const [drawerOpen, setDrawerOpen] = useState(false);
//     const [isOnline, setIsOnline] = useState(false);
//     const [refresh, setRefresh] = useState(0);

//     // 🔥 Detect mobile screen
//     const isMobile = useMediaQuery('(max-width:600px)');

//     // ✅ Create a ref for the dropdown container
//     const dropdownRef = useRef(null);
//     const accountButtonRef = useRef(null);

//     // ✅ Get saved online/offline status
//     useEffect(() => {
//         const savedStatus = localStorage.getItem("isOnline");
//         if (savedStatus !== null) {
//             setIsOnline(savedStatus === "true");
//         }
//     }, []);

//     // ✅ Listen for cart update events
//     useEffect(() => {
//         const handleCartUpdate = () => {
//             setRefresh(prev => prev + 1);
//         };

//         // Listen for cart update events
//         window.addEventListener('cartUpdated', handleCartUpdate);

//         // Cleanup
//         return () => {
//             window.removeEventListener('cartUpdated', handleCartUpdate);
//         };
//     }, []);

//     // ✅ Click outside listener
//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             // Close dropdown if clicked outside of both dropdown and account button
//             if (
//                 showContainer &&
//                 dropdownRef.current &&
//                 !dropdownRef.current.contains(event.target) &&
//                 accountButtonRef.current &&
//                 !accountButtonRef.current.contains(event.target)
//             ) {
//                 setShowContainer(false);
//             }
//         };

//         // Add event listener
//         document.addEventListener("mousedown", handleClickOutside);

//         // Cleanup
//         return () => {
//             document.removeEventListener("mousedown", handleClickOutside);
//         };
//     }, [showContainer]);

//     // ✅ Logout functionality
//     const handleLogout = async () => {
//         try {
//             const authToken = localStorage.getItem("authToken");
//             await axios.post(
//                 "https://backend.maamaas.com/food/api/auth/logout",
//                 {},
//                 { headers: { Authorization: `Bearer ${authToken}` } }
//             );
//         } catch (error) {
//             console.error("❌ Logout API failed:", error);
//         } finally {
//             localStorage.removeItem("authToken");
//             localStorage.removeItem("vendorId");
//             setShowContainer(false);
//             setDrawerOpen(false);
//             navigate("/");
//         }
//     };

//     // ✅ Fetch all cart items (no orderType filter)
//     const fetchCartData = async () => {
//         const vendorId = localStorage.getItem("vendorId");
//         if (!vendorId) return;

//         try {
//             const token = localStorage.getItem("authToken");
//             const response = await axios.get(
//                 `https://backend.maamaas.com/food/api/cart/vendor/count/${vendorId}`,
//                 { headers: { Authorization: `Bearer ${token}` } }
//             );

//             let items = [];
//             let count = 0;

//             if (Array.isArray(response.data.cartItems)) {
//                 items = response.data.cartItems;
//                 count = items.length;
//             } else if (typeof response.data.cartItemsCount === "number") {
//                 count = response.data.cartItemsCount;
//             } else if (typeof response.data === "number") {
//                 count = response.data;
//             }

//             setCartItems(items);
//             setCartCount(count);
//         } catch (error) {
//             console.error("Error fetching cart data:", error);
//         }
//     };

//     // ✅ Fetch restaurant status
//     const fetchVendorStatus = async () => {
//         const vendorId = localStorage.getItem("vendorId");
//         if (!vendorId) return;

//         try {
//             const token = localStorage.getItem("authToken");
//             const response = await axios.get(
//                 `https://backend.maamaas.com/food/api/vendors/Restaurent-stauts/${vendorId}`,
//                 { headers: { Authorization: `Bearer ${token}` } }
//             );

//             if (response.data && typeof response.data.online === "boolean") {
//                 setIsOnline(response.data.online);
//             }
//         } catch (error) {
//             console.error("Error fetching vendor status:", error);
//         }
//     };

//     // ✅ Toggle restaurant open/close
//     const handleToggleStatus = async (event) => {
//         const newStatus = event.target.checked;
//         setIsOnline(newStatus);

//         const vendorId = localStorage.getItem("vendorId");
//         if (!vendorId) {
//             alert("Vendor ID missing!");
//             return;
//         }

//         localStorage.setItem("isOnline", newStatus);

//         try {
//             const token = localStorage.getItem("authToken");
//             const response = await axios.put(
//                 `https://backend.maamaas.com/food/api/vendors/Restaurent-stauts/${vendorId}`,
//                 { online: newStatus },
//                 { headers: { Authorization: `Bearer ${token}` } }
//             );

//             console.log("Status Update Response:", response.data);



//         } catch (error) {
//             console.error("Error updating vendor status:", error);

//             // ❌ Show backend error message if available
//             if (error.response) {
//                 alert(
//                     `Error: Failed to update status!\n\n` +
//                     JSON.stringify(error.response.data, null, 2)
//                 );
//             } else {
//                 alert("Network or server error: " + error.message);
//             }
//         }
//     };

//     // ✅ FIXED: Add refresh dependency to refetch cart data when refresh changes
//     useEffect(() => {
//         fetchCartData();
//         fetchVendorStatus();
//     }, [refresh]); // ← This is the key fix

//     const toggleDrawer = (open) => () => setDrawerOpen(open);

//     // ✅ Handle account button click
//     const handleAccountClick = () => {
//         setShowContainer(!showContainer);
//     };

//     // ✅ Handle menu item click (close dropdown when menu item is clicked)
//     const handleMenuItemClick = (action) => {
//         setShowContainer(false);
//         if (action === "subscription") {
//             navigate("/landingpagesubscription");
//         } else if (action === "logout") {
//             handleLogout();
//         }
//     };

//     const DrawerContent = (
//         <Box sx={{ width: 250, padding: 2 }} role="presentation">
//             <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>MAAMAA'S</Typography>
//             <Divider />
//         </Box>
//     );

//     return (
//         <>
//             <AppBar position="fixed" elevation={0} sx={{ background: "#B15DC6", zIndex: 1300 }}>
//                 <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

//                     {/* Left Side - Logo */}
//                     <Typography
//                         variant="h6"
//                         sx={{ fontWeight: "bold", color: "#fff", fontSize: "26px", cursor: "pointer" }}
//                         onClick={() => navigate("/fooddashboard")}
//                     >
//                         MAAMAA'S
//                     </Typography>

//                     {/* Right Side */}
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>

//                         {/* 🔥 Hide switch on mobile */}
//                         {/* {!isMobile && (
//                             <FormControlLabel
//                                 control={
//                                     <Switch
//                                         checked={isOnline}
//                                         onChange={handleToggleStatus}
//                                         color="primary"
//                                         sx={{
//                                             '& .MuiSwitch-switchBase.Mui-checked': {
//                                                 color: '#00d807ff', // Green when checked (Open)
//                                             },
//                                             '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
//                                                 backgroundColor: '#24e22aff', // Green track when checked
//                                             },
//                                             '& .MuiSwitch-switchBase': {
//                                                 color: '#4e4d4b', // Red when unchecked (Closed)
//                                             },
//                                             '& .MuiSwitch-track': {
//                                                 backgroundColor: '#727170ff', // Red track when unchecked
//                                             },
//                                         }}
//                                     />
//                                 }
//                                 label={
//                                     <Typography
//                                         sx={{
//                                             color: isOnline ? "#03da0aff" : "#4e4d4b", // Green for Open, Red for Closed
//                                             fontSize: "1.3rem",
//                                             marginTop: "3px"
//                                         }}
//                                     >
//                                         {isOnline ? "Open" : "Closed"}
//                                     </Typography>
//                                 }
//                                 sx={{ fontWeight: "bold", marginTop: "3px" }}
//                             />
//                         )} */}

//                         {/* Cart Button */}
//                         {/* <IconButton onClick={() => navigate("/foodcart")} sx={{ color: "white" }}>
//                             <Badge
//                                 badgeContent={cartCount}
//                                 color="error"
//                                 sx={{
//                                     '& .MuiBadge-badge': {
//                                         backgroundColor: '#4e4d4b',
//                                         color: 'white',
//                                         borderRadius: '4px',
//                                         padding: '0 6px',
//                                         minWidth: '20px',
//                                         height: '20px',
//                                     }
//                                 }}
//                             >
//                                 <ShoppingCartIcon fontSize="large" />
//                             </Badge>
//                         </IconButton> */}

//                         {/* User Profile Button */}
//                         <IconButton
//                             ref={accountButtonRef}
//                             onClick={handleAccountClick}
//                             sx={{ color: "white" }}
//                         >
//                             <AccountCircleIcon fontSize="large" />
//                         </IconButton>
//                     </Box>
//                 </Toolbar>

//                 {/* Account Dropdown */}
//                 {showContainer && (
//                     <Paper
//                         ref={dropdownRef}
//                         sx={{
//                             position: "absolute",
//                             top: "60px",
//                             right: "10px",
//                             width: "120px",
//                             backgroundColor: "white",
//                             boxShadow: 3,
//                             borderRadius: "8px",
//                             zIndex: 1000
//                         }}
//                     >
//                         <MenuItem onClick={() => handleMenuItemClick("subscription")}>
//                             Subscription
//                         </MenuItem>
//                         <MenuItem onClick={() => handleMenuItemClick("logout")}>
//                             Logout
//                         </MenuItem>
//                     </Paper>
//                 )}
//             </AppBar>

//             {/* Drawer */}
//             <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
//                 {DrawerContent}
//             </Drawer>
//         </>
//     );
// };

// export default Foodandbevaragenavbar;









// //  const handlePrint = () => {
// //         // Check for order data (important for auto-print)
// //         if (!orderData || !orderData.orderId) {
// //             console.error("No order data available for printing");
// //             return;
// //         }

// //         // Store original content (only needed for manual print)
// //         const originalContent = document.body.innerHTML;

// //         const printStyles = `
// //     <style>
// //     @media print {
// //         body {
// //             width: 80mm !important;
// //             margin: 0 auto !important;
// //             padding: 0 !important;
// //             font-family: "Courier New", monospace !important;
// //             font-size: 10px !important;
// //             line-height: 1.2 !important;
// //             font-weight:900 !important;
// //         }

// //         h1, h2, h3 {
// //             font-weight: bold;
// //             text-align: center;
// //             margin: 0;
// //             padding: 0;
// //         }

// //         .big-title {
// //             font-size: 14px !important;
// //             font-weight: bold;
// //             text-align: center;
// //             margin-bottom: 5px;
// //         }

// //         .center-text {
// //             text-align: center;
// //             font-size: 10px;
// //             font-weight: bold;
// //         }

// //         .line {
// //             border-top: 1px solid black;
// //             margin: 6px 0;
// //         }

// //         .dashed {
// //             border-top: 1px dashed black;
// //             margin: 6px 0;
// //         }

// //         table {
// //             width: 100%;
// //             font-size: 10px;
// //             border-collapse: collapse;
// //         }

// //         th{
// //             padding: 0px 0px;
// //             font-weight: bold;
// //         }
// //         td { 
// //             padding: 2px 0px;
// //             font-weight: bold;
// //         }

// //         .row {
// //             display: flex;
// //             justify-content: space-around;
// //             font-size: 10px;
// //             font-weight: bold;
// //             white-space: nowrap;
// //             width: 100%;

// //         }

// //         .grand-label {
// //             font-size: 16px;
// //             font-weight: bold;
// //         }

// //         .grand-value {
// //             font-size: 16px;
// //             font-weight: bold;
// //         }

// //         .footer {
// //             text-align: center;
// //             margin-top: 10px;
// //             font-size: 10px;
// //         }

// //         .receipt-buttons, button {
// //             display: none !important;
// //         }

// //         @page {
// //             size: 80mm auto;
// //             margin: 0;
// //         }

// //         .page-break {
// //             page-break-after: always;
// //         }
// //     }
// //     </style>
// //     `;

// //         // SIMPLE RECEIPT (Top Image) - HARDCODED "Take A Break"
// //         const receiptOne = `
// //         <div class="big-title">Take A Break</div>
// //         <div class="line"></div>

// //         <div class="row"><span>OrderID: ${orderData.orderId}</span><span>Date: ${orderData.date || new Date().toLocaleDateString('en-GB')}</span></div>
// //         <div class="row"><span>Type: ${orderData.orderType || "Dine In"}</span><span>Time: ${orderData.time || new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</span></div>

// //         <div class="center-text">Payment: ${orderData.paymentMethod || "Cash"}</div>

// //         <div class="line"></div>

// //         <table>
// //             <thead>
// //                 <tr>
// //                     <th style="text-align:center;">Item</th>
// //                     <th style="text-align:center;">Qty</th>
// //                 </tr>
// //             </thead>
// //             <tbody>
// //                 ${Array.isArray(orderData.order) ? orderData.order.map(item => `
// //                     <tr>
// //                         <td style="text-align:center;">${item.dishName || "Item"}</td>
// //                         <td style="text-align:center;">${item.quantity || 1}</td>
// //                     </tr>
// //                 `).join("") : ""}
// //             </tbody>
// //         </table>

// //         <div class="line"></div>
// //     `;

// //         // DETAILED RECEIPT (Bottom Image) - HARDCODED "Take A Break"
// //         const receiptTwo = `
// //         <div class="big-title">Take A Break</div>
// //         <div class="center-text">GSTIN: ${orderData?.vendorGstIn || "N/A"}</div>
// //         <div class="line"></div>

// //         <div class="row"><span>OrderID: ${orderData.orderId}</span><span>Date: ${orderData.date || new Date().toLocaleDateString('en-GB')}</span></div>
// //         <div class="row"><span>Type: ${orderData.orderType || "Dine In"}</span><span>Time: ${orderData.time || new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}</span></div>
// //         <div class="center-text">Payment: ${orderData.paymentMethod || "Cash"}</div>

// //         <div class="line"></div>

// //         <table class="items-table">
// //             <thead>
// //                 <tr>
// //                     <th style="text-align:center;">Item</th>
// //                     <th style="text-align:center;">Qty</th>
// //                     <th style="text-align:center;">Price</th>
// //                     <th style="text-align:center;">Total</th>
// //                 </tr>
// //             </thead>
// //             <tbody>
// //                 ${Array.isArray(orderData.order) ? orderData.order.map(item => `
// //                     <tr>
// //                         <td style="text-align:center;">${item.dishName || "Item"}</td>
// //                         <td style="text-align:center;">${item.quantity || 1}</td>
// //                         <td style="text-align:center;">₹${(item.price || 0).toFixed(2)}</td>
// //                         <td style="text-align:center;">₹${((item.price || 0) * (item.quantity || 1)).toFixed(2)}</td>
// //                     </tr>
// //                 `).join("") : ""}
// //             </tbody>
// //         </table>

// //         <div class="line"></div>

// //         <div class="row"><span>SubTotal</span><span>₹${(orderData.subTotal || 0).toFixed(2)}</span></div>
// //         <div class="row"><span>Platform</span><span>₹${(orderData.platformCharges || 0).toFixed(2)}</span></div>
// //         <div class="row"><span>Service</span><span>₹${(orderData.serviceCharge || 0).toFixed(2)}</span></div>
// //         <div class="row"><span>CGST</span><span>₹${(orderData.cgst || 0).toFixed(2)}</span></div>
// //         <div class="row"><span>SGST</span><span>₹${(orderData.sgst || 0).toFixed(2)}</span></div>

// //         <div class="line"></div>

// //         <div class="row">
// //             <span class="grand-label">Grand Total</span>
// //             <span class="grand-value">₹${(orderData.grandTotal || 0).toFixed(2)}</span>
// //         </div>

// //         <div class="dashed"></div>
// //         <div class="center-text">FSSAI: ${orderData?.vendorFssai || "23624032003384"}</div>

// //         <div class="footer">
// //             Thank you, visit again<br/>
// //             www.maamaas.com
// //         </div>
// //     `;

// //         // FINAL PRINT CONTENT
// //         const finalHTML = `
// //         <!DOCTYPE html>
// //         <html>
// //         <head>
// //             <title>Receipt - ${orderData.orderId || 'Order'}</title>
// //             ${printStyles}
// //         </head>
// //         <body>
// //             ${receiptOne}
// //             <div class="page-break"></div>
// //             ${receiptTwo}
// //         </body>
// //         </html>
// //     `;

// //         try {
// //             const printWindow = window.open('', '_blank', 'width=800,height=600');
// //             printWindow.document.open();
// //             printWindow.document.write(finalHTML);
// //             printWindow.document.close();

// //             printWindow.onload = () => {
// //                 printWindow.print();

// //                 // Listen for afterprint event
// //                 printWindow.onafterprint = () => {
// //                     setTimeout(() => {
// //                         printWindow.close();

// //                         // AUTO-REFRESH: Only for manual prints, not auto-prints
// //                         // Check if we're in auto-print mode by seeing if receipt is showing
// //                         if (showReceipt) {
// //                             // This is auto-print - don't refresh, let auto-print handle closing
// //                             console.log("Auto-print completed, not refreshing");
// //                         } else {
// //                             // This is manual print - refresh the page
// //                             window.location.reload();
// //                         }
// //                     }, 500);
// //                 };

// //                 // Fallback in case afterprint doesn't fire
// //                 setTimeout(() => {
// //                     printWindow.close();

// //                     // Same logic: only refresh for manual prints
// //                     if (!showReceipt) {
// //                         window.location.reload();
// //                     }
// //                 }, 3000);
// //             };

// //             // Only restore original content for MANUAL prints
// //             // Auto-print doesn't need this since we're not modifying the page
// //             if (!showReceipt) {
// //                 document.body.innerHTML = originalContent;
// //             }

// //         } catch (error) {
// //             console.error("Print error:", error);
// //             // Restore page on error
// //             if (!showReceipt) {
// //                 document.body.innerHTML = originalContent;
// //             }
// //         }
// //     };




import {
    AppBar, Toolbar, Typography, Box, IconButton, MenuItem,
    Paper, Badge, Drawer, Divider, Switch, FormControlLabel
} from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import MenuIcon from "@mui/icons-material/Menu"; // ← Add this import
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useSidebar } from "../../context/SidebarContext";


const Foodandbevaragenavbar = ({ onMenuToggle }) => { // ← Accept prop from parent    const navigate = useNavigate();
    const [showContainer, setShowContainer] = useState(false);
    const [cartCount, setCartCount] = useState(0);
    const [cartItems, setCartItems] = useState([]);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [isOnline, setIsOnline] = useState(false);
    const [refresh, setRefresh] = useState(0);
    const navigate = useNavigate();
    const { toggleSidebar, sidebarOpen } = useSidebar(); // ← Add sidebarOpen


    // 🔥 Detect mobile screen
    const isMobile = useMediaQuery('(max-width:600px)');
    const isBelow992 = useMediaQuery('(max-width:991px)'); // ← Add this
    const isAbove900 = useMediaQuery('(min-width:992px)'); // ← And this
    // ✅ Create a ref for the dropdown container
    const dropdownRef = useRef(null);
    const accountButtonRef = useRef(null);


    // ✅ Get saved online/offline status
    useEffect(() => {
        const savedStatus = localStorage.getItem("isOnline");
        if (savedStatus !== null) {
            setIsOnline(savedStatus === "true");
        }
    }, []);

    // ✅ Listen for cart update events
    useEffect(() => {
        const handleCartUpdate = () => {
            setRefresh(prev => prev + 1);
        };

        // Listen for cart update events
        window.addEventListener('cartUpdated', handleCartUpdate);

        // Cleanup
        return () => {
            window.removeEventListener('cartUpdated', handleCartUpdate);
        };
    }, []);

    // ✅ Click outside listener
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Close dropdown if clicked outside of both dropdown and account button
            if (
                showContainer &&
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target) &&
                accountButtonRef.current &&
                !accountButtonRef.current.contains(event.target)
            ) {
                setShowContainer(false);
            }
        };

        // Add event listener
        document.addEventListener("mousedown", handleClickOutside);

        // Cleanup
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showContainer]);

    // ✅ Logout functionality
    const handleLogout = async () => {
        try {
            const authToken = localStorage.getItem("authToken");
            await axios.post(
                "https://backend.maamaas.com/food/api/auth/logout",
                {},
                { headers: { Authorization: `Bearer ${authToken}` } }
            );
        } catch (error) {
            console.error("❌ Logout API failed:", error);
        } finally {
            localStorage.removeItem("authToken");
            localStorage.removeItem("vendorId");
            setShowContainer(false);
            setDrawerOpen(false);
            navigate("/");
        }
    };

    // ✅ Fetch all cart items (no orderType filter)
    const fetchCartData = async () => {
        const vendorId = localStorage.getItem("vendorId");
        if (!vendorId) return;

        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/cart/vendor/count/${vendorId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            let items = [];
            let count = 0;

            if (Array.isArray(response.data.cartItems)) {
                items = response.data.cartItems;
                count = items.length;
            } else if (typeof response.data.cartItemsCount === "number") {
                count = response.data.cartItemsCount;
            } else if (typeof response.data === "number") {
                count = response.data;
            }

            setCartItems(items);
            setCartCount(count);
        } catch (error) {
            console.error("Error fetching cart data:", error);
        }
    };

    // ✅ Fetch restaurant status
    const fetchVendorStatus = async () => {
        const vendorId = localStorage.getItem("vendorId");
        if (!vendorId) return;

        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/vendors/Restaurent-stauts/${vendorId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.data && typeof response.data.online === "boolean") {
                setIsOnline(response.data.online);
            }
        } catch (error) {
            console.error("Error fetching vendor status:", error);
        }
    };

    // ✅ Toggle restaurant open/close
    const handleToggleStatus = async (event) => {
        const newStatus = event.target.checked;
        setIsOnline(newStatus);

        const vendorId = localStorage.getItem("vendorId");
        if (!vendorId) {
            alert("Vendor ID missing!");
            return;
        }

        localStorage.setItem("isOnline", newStatus);

        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.put(
                `https://backend.maamaas.com/food/api/vendors/Restaurent-stauts/${vendorId}`,
                { online: newStatus },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            console.log("Status Update Response:", response.data);



        } catch (error) {
            console.error("Error updating vendor status:", error);

            // ❌ Show backend error message if available
            if (error.response) {
                alert(
                    `Error: Failed to update status!\n\n` +
                    JSON.stringify(error.response.data, null, 2)
                );
            } else {
                alert("Network or server error: " + error.message);
            }
        }
    };

    // ✅ FIXED: Add refresh dependency to refetch cart data when refresh changes
    useEffect(() => {
        fetchCartData();
        fetchVendorStatus();
    }, [refresh]); // ← This is the key fix

    const toggleDrawer = (open) => () => setDrawerOpen(open);


    const DrawerContent = (
        <Box sx={{ width: 250, padding: 2 }} role="presentation">
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>MAAMAA'S</Typography>
            <Divider />
        </Box>
    );

    // ✅ Handle account button click
    const handleAccountClick = () => {
        setShowContainer(!showContainer);
    };

    // ✅ Handle menu item click
    const handleMenuItemClick = (action) => {
        setShowContainer(false);
        if (action === "subscription") {
            navigate("/landingpagesubscription");
        } else if (action === "logout") {
            handleLogout();
        }
    };

    // ✅ Handle hamburger menu click
    const handleHamburgerClick = () => {
        if (onMenuToggle) {
            onMenuToggle(); // Call parent function to toggle sidebar
        }
    };


    return (
        <>
            <AppBar position="fixed" elevation={0} sx={{ background: "#B15DC6", zIndex: 1300 }}>
                <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                    {/* Left Side - Hamburger Menu + Logo */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        {/* Hamburger Menu Icon - Only show below 992px */}
                        {isBelow992 && (
                            <IconButton
                                edge="start"
                                color="inherit"
                                aria-label="menu"
                                onClick={toggleSidebar}
                                sx={{
                                    color: "#fff",
                                    '&:hover': {
                                        backgroundColor: 'rgba(255, 255, 255, 0.1)'
                                    }
                                }}
                            >
                                <MenuIcon fontSize="large" />
                            </IconButton>
                        )}

                        {/* Logo */}
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: "bold",
                                color: "#fff",
                                fontSize: "26px",
                                cursor: "pointer",
                                marginLeft: isBelow992 ? 1 : 0
                            }}
                            onClick={() => navigate("/fooddashboard")}
                        >
                            MAAMAA'S
                        </Typography>
                    </Box>

                    {/* Right Side */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>

                        {/* User Profile Button */}
                        <IconButton
                            ref={accountButtonRef}
                            onClick={handleAccountClick}
                            sx={{ color: "white" }}
                        >
                            <AccountCircleIcon fontSize="large" />
                        </IconButton>
                    </Box>
                </Toolbar>

                {/* Account Dropdown */}
                {showContainer && (
                    <Paper
                        ref={dropdownRef}
                        sx={{
                            position: "absolute",
                            top: "60px",
                            right: "10px",
                            width: "120px",
                            backgroundColor: "white",
                            boxShadow: 3,
                            borderRadius: "8px",
                            zIndex: 1000
                        }}
                    >
                        <MenuItem onClick={() => handleMenuItemClick("subscription")}>
                            Subscription
                        </MenuItem>
                        <MenuItem onClick={() => handleMenuItemClick("logout")}>
                            Logout
                        </MenuItem>
                    </Paper>
                )}
            </AppBar>
        </>
    );
};

export default Foodandbevaragenavbar;




